import { render, staticRenderFns } from "./SmsConsentReview.vue?vue&type=template&id=5eb2c124&scoped=true&lang=pug"
import script from "./SmsConsentReview.vue?vue&type=script&lang=js"
export * from "./SmsConsentReview.vue?vue&type=script&lang=js"
import style0 from "./SmsConsentReview.vue?vue&type=style&index=0&id=5eb2c124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2c124",
  null
  
)

export default component.exports